import { useState } from 'react';
import { AppDialog } from '../../../components/AppDialog';
import { RichTextEditor } from '../systemManagement/RichTextEditor';
import './preLoginSettings.css';

/** Legacy `COCSettings_DetailView_SpecialNotes` — the modal the "Special Notes"
 *  checkbox opens. OK writes the note back to the record being edited (not to the
 *  database - the form's own Save does that); Cancel discards the edit. */
export default function SpecialNotesDialog({ value, onClose, onOk }: {
  value: string;
  onClose: () => void;
  onOk: (html: string) => void;
}) {
  const [text, setText] = useState(value);
  return (
    <AppDialog
      open onClose={onClose} title="Special Notes" icon="ti-notes" width={640}
      footer={<>
        <button className="ca-btn" onClick={onClose}>Cancel</button>
        <button className="ca-btn ca-btn-solid" onClick={() => onOk(text)}><i className="ti ti-check" /> OK</button>
      </>}
    >
      <RichTextEditor value={text} onChange={setText} variant="full" hideSourceTabs />
    </AppDialog>
  );
}
